/**
 * Tooltip 组件的 emit 事件声明
 */
export const emits = [
  /** 显隐状态变化，配合 v-model:visible 使用 */
  'update:visible',
  /** 点击 Tooltip 外部区域时触发 */
  'clickOutside',
];
